import { IPageTabNavLink } from "../interfaces-and-types";

export const transfersNavLinks: IPageTabNavLink[] = [
  {
    name: "Transfers",
    route: "",
  },
];
